<template>
  <div class="">
    <!-- <div class="relative pt-32 bg-white"> -->
    <!-- <div class="absolute bg-design1 mob-hidden">
        <img
          src="../../assets/images/bg-des/bgd1.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute bg-design2 mob-hidden">
        <img src="../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
      </div>
      <div class="absolute top-32 right-0 md:block lg:block hidden">
        <img
          src="./../../assets/images/bg-des/career-dots.svg"
          alt="Dots"
          class=""
        />
      </div>
      <div class="absolute bg-designreg2 left-0 md:block lg:block hidden">
        <img
          src="./../../assets/images/bg-des/career-dots.svg"
          alt="Dots"
          class=""
        />
      </div>
      <div class="absolute bottom-32 right-0 md:block lg:block hidden">
        <img
          src="./../../assets/images/bg-des/CD-dots2.svg"
          alt="Dots"
          class=""
        />
      </div>
      <div class="absolute top-1/4 right-1/4 md:block lg:block hidden">
        <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
      </div>
      <div class="absolute top-1/2 left-20 md:block lg:block hidden">
        <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
      </div> -->
    <div class="md:w-4/5 lg:w-4/5 w-full px-6 md:px-0 lg:px-0 mx-auto">
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(register)">
          <div class="md:pt-10 lg:pt-10 pt-8">
            <div class="pt-4 w-full">
              <div class="md:flex">
                <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                  <p class="input-title-black">First Name</p>
                  <base-input
                    :rules="{ required: true, alpha: true }"
                    v-model="userData.firstname"
                    placeholder="Enter First Name"
                    name="First Name"
                    class="cust-form-border"
                  ></base-input>
                </div>
                <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
                  <p class="input-title-black">Last Name</p>
                  <base-input
                    :rules="{ required: true, alpha: true }"
                    name="Last Name"
                    v-model="userData.lastname"
                    placeholder="Enter Last Name"
                    class="cust-form-border"
                  ></base-input>
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="w-full">
              <div class="md:flex">
                <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                  <p class="input-title-black">Email Address</p>
                  <base-input
                    :rules="{ required: true, email: true }"
                    name="Email"
                    v-model="userData.email"
                    placeholder="Enter your EmailID"
                    class="cust-form-border"
                  ></base-input>
                </div>
                <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
                  <p class="input-title-black">Phone</p>
                  <base-input
                    :rules="{
                      numeric: true,
                      required: true,
                      min: 10,
                      max: 15,
                    }"
                    name="mobile"
                    v-model="userData.mobile"
                    placeholder="Enter your Phone no."
                    class="cust-form-border"
                  ></base-input>
                  <!-- <p class="input-title-black">Password</p>
                    <base-input
                      :rules="{ required: true, min: 6 }"
                      name="password"
                      v-model="password"
                      placeholder="xxxxxxxx"
                      class="cust-form-border"
                      type="password"
                    ></base-input> -->
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="w-full">
              <div class="md:flex">
                <!-- <div class="md:w-1/2 lg:w-1/2 w-full pt-4 relative">
                    <p class="input-title-black">Phone</p>
                    <base-input
                      :rules="{
                        numeric: true,
                        required: true,
                        min: 10,
                        max: 15,
                      }"
                      name="mobile"
                      v-model="mobile"
                      placeholder="Enter your Phone no."
                      class="cust-form-border"
                    ></base-input>
                    <countdown
                      :time="time"
                      v-if="OTPCountdown"
                      @start="handleCountdownStart"
                      @end="handleCountdownEnd"
                    >
                      <template slot-scope="props">
                        <div class="flex items-center">
                          <span class="timer">{{ props.seconds }}</span>
                          <span class="text-sm ml-2">Seconds left </span>
                        </div>
                      </template>
                    </countdown>
                    <div
                      class="absolute right-4 top-12 cursor-pointer hover:bg-primary hover:text-white text-primary"
                      v-if="mobile.length >= 10"
                    >
                      <p class="" @click="handleClick">Get OTP</p>
                    </div>
                  </div>  -->
              </div>
            </div>
          </div>
          <validation-provider
            :rules="{ required: true }"
            name="age"
            v-slot="{ errors }"
          >
            <div class="mt-4">
              <p class="input-title-black font-semibold">Age</p>
              <span
                class="invalid-feedback"
                style="display: block"
                v-if="errors[0]"
              >
                {{ errors[0] }}
              </span>
              <div
                class="mt-4 lg:grid lg:grid-cols-3 md:grid md:grid-cols-3 grid grid-cols-2 justify-between"
              >
                <div class="lg:w-1/2 md:w-1/2 w-3/4">
                  <b-form-radio
                    v-model="profileData[0].age"
                    name="age"
                    value="15-20"
                    ><p>15-20</p></b-form-radio
                  >
                </div>
                <div class="lg:w-1/2 md:w-1/2 w-3/4">
                  <b-form-radio
                    v-model="profileData[0].age"
                    name="age"
                    value="20-30"
                    ><p>20-30</p></b-form-radio
                  >
                </div>
                <div class="lg:w-1/2 md:w-1/2 w-3/4">
                  <b-form-radio
                    v-model="profileData[0].age"
                    name="age"
                    value="30-50"
                    ><p>30-50</p></b-form-radio
                  >
                </div>

                <div class="lg:w-1/2 md:w-1/2 w-3/4">
                  <b-form-radio
                    v-model="profileData[0].age"
                    name="age"
                    value="50-70"
                    ><p>50-70</p></b-form-radio
                  >
                </div>
                <div class="lg:w-4/5 md:w-4/5 w-full">
                  <b-form-radio
                    v-model="profileData[0].age"
                    name="age"
                    value="More than 70"
                    ><p>More than 70</p></b-form-radio
                  >
                </div>
              </div>
            </div>
          </validation-provider>
          <!-- <validation-provider
            :rules="{ required: true }"
            name="occupation"
            v-slot="{ errors }"
          >
            <div class="mt-12">
              <p class="input-title-black font-semibold">Occupation</p>
              <span
                class="invalid-feedback"
                style="display: block"
                v-if="errors[0]"
              >
                {{ errors[0] }}
              </span>
              <div class="mt-4 md:flex justify-between">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].occupation"
                    name="occupation"
                    value="Main income provider"
                    ><p>Main income provider</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].occupation"
                    name="occupation"
                    value="Secondary income provider"
                    ><p>Secondary income provider</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].occupation"
                    name="occupation"
                    value="Not working"
                    ><p>Not working</p></b-form-radio
                  >
                </div>
              </div>
            </div>
          </validation-provider> -->

          <div class="locationcity">
            <div class="pt-4 w-full">
              <div class="md:flex">
                <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                  <p class="input-title-black">Location</p>
                  <base-input
                    v-model="profileData[0].address"
                    placeholder="Enter your location"
                    class="cust-form-border"
                    :rules="{ required: true }"
                    name="location"
                  >
                  </base-input>
                  <!-- , alpha_num: true  -->
                </div>
                <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
                  <p class="input-title-black">City</p>
                  <base-input
                    v-model="profileData[0].city"
                    placeholder="Enter your city"
                    class="cust-form-border"
                    name="city"
                    :rules="{ required: true, alpha_num: true }"
                  ></base-input>
                </div>
              </div>
            </div>
          </div>
          <div class="locationcity">
            <div class="pt-4 w-full">
              <div class="md:flex">
                <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                  <p class="input-title-black">
                    What is your Whatsapp number? (in case you have a different
                    number)
                  </p>
                  <base-input
                    v-model="profileData[0].whatsappNo"
                    placeholder="Enter your Whatsapp Number"
                    class="cust-form-border"
                    :rules="{
                      numeric: true,
                      required: true,
                      min: 10,
                      max: 10,
                    }"
                    name="Mobile Number"
                  >
                  </base-input>
                  <!-- , alpha_num: true  -->
                </div>
                <div
                  class="md:pl-4 lg:pl-4 ml-0 mt-10 md:w-1/2 lg:w-1/2 w-full"
                >
                  <p class="input-title-black">Current Profession</p>
                  <base-input
                    :rules="{
                      required: true,
                    }"
                    v-model="profileData[0].profession"
                    placeholder="Enter your Current Profession"
                    class="cust-form-border"
                    name="current profession"
                  ></base-input>
                </div>
              </div>
            </div>
          </div>
          <div class="locationcity">
            <div class="pt-4 w-full">
              <div class="md:flex">
                <div class="w-full pt-4">
                  <p class="input-title-black">
                    There are various ways you could relate to in a category,
                    which one do you relate with the most currently?
                  </p>

                  <base-input :rules="{ required: true }" name="Category">
                    <select
                      v-model="profileData[0].roleType"
                      class="form-control"
                    >
                      <option value="" disabled>Please select an option</option>
                      <option value="Caregiver">Caregiver</option>
                      <option value="Well Wisher of the caregiver">
                        Well Wisher of the caregiver
                      </option>
                      <option value="volunteer">Volunteer</option>
                      <option
                        value="Healthcare Professional/Profession Caregiver/Nurse"
                      >
                        Healthcare Professional/Profession Caregiver/Nurse
                      </option>
                      <option value="Coach">Coach</option>
                      <option value="Psychologist">Psychologist</option>
                      <option value="Yoga Therapist">Yoga Therapist</option>
                      <option value="financial advisor">
                        Financial Advisor
                      </option>
                      <option value="Legal Expert">Legal Expert</option>
                      <option value="Intern">Intern</option>
                      <option value="Other">Other</option>
                    </select>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
          <!-- <validation-provider
            :rules="{ required: true }"
            name="role"
            v-slot="{ errors }"
          >
            <div class="mt-12">
              <p class="input-title-black font-semibold">
                Which of the following do you identify with as being your role?
              </p>
              <span
                class="invalid-feedback"
                style="display: block"
                v-if="errors[0]"
              >
                {{ errors[0] }}
              </span>
              <div class="mt-4 md:flex justify-between">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].roleType"
                    name="role"
                    value="Prime Caregiver"
                    ><p>Primary Caregiver</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].roleType"
                    name="role"
                    value="Healthcare Proffesional"
                    ><p>Healthcare Professional</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].roleType"
                    name="role"
                    value="Have been a Caregiver"
                    ><p>Have been a Caregiver</p></b-form-radio
                  >
                </div>
              </div>
              <div class="mt-4 md:flex justify-between">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].roleType"
                    name="role"
                    value="Will be a Caregiver"
                    ><p>Will be a Caregiver</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].roleType"
                    name="role"
                    value="Need Caregiving"
                    ><p>Need Caregiving</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].roleType"
                    name="role"
                    value="Well-wisher of a Caregiver"
                    ><p>Well-wisher of a Caregiver</p></b-form-radio
                  >
                </div>
              </div>
            </div>
          </validation-provider> -->
          <!-- <div class="locationcity">
            <div class="pt-4 w-full">
              <div class="md:flex">
                <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                  <p class="input-title-black">
                    How long have you been/were in this role for?
                  </p>
                  <base-input
                    v-model="profileData[0].experience"
                    placeholder=""
                    class="cust-form-border"
                    :rules="{ required: true, alpha_num: true }"
                    name="experience"
                  ></base-input>
                </div>
              </div>
            </div>
          </div> -->
          <div v-if="profileData[0].roleType == 'Caregiver'">
            <validation-provider
              :rules="{ required: true }"
              name="care"
              v-slot="{ errors }"
            >
              <div class="mt-4">
                <div class="pt-4 w-full">
                  <div class="md:flex">
                    <div class="md:w-1/2 lg:w-1/2 w-full pt-4 mt-9px">
                      <p class="input-title-black">
                        Who are you providing care for?
                      </p>
                      <base-input
                        v-model="profileData[0].careForPatient"
                        placeholder="Enter your Whatsapp Number"
                        class="cust-form-border"
                        :rules="{
                          required: true,
                        }"
                        name="care"
                      >
                      </base-input>
                      <!-- , alpha_num: true  -->
                    </div>
                    <div class="md:pl-4 lg:pl-4 ml-0 md:w-1/2 lg:w-1/2 w-full">
                      <p class="input-title-black">
                        For how long you been in the caregiving role?
                      </p>
                      <base-input
                        :rules="{
                          numeric: true,
                          required: true,
                        }"
                        v-model="profileData[0].experience"
                        placeholder="Enter your Current Profession"
                        class="cust-form-border"
                        name="years"
                      ></base-input>
                    </div>
                  </div>
                </div>
                <p class="input-title-black font-semibold mt-12">
                  Which category of caregiver do you belong to?
                </p>
                <span
                  class="invalid-feedback"
                  style="display: block"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </span>
                <div class="mt-4 md:flex justify-between">
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="profileData[0].category"
                      name="Primary Caregiver"
                      value="primaryCaregiver"
                      ><p>Primary Caregiver</p></b-form-radio
                    >
                  </div>
                  <div class="w-2/3">
                    <b-form-radio
                      v-model="profileData[0].category"
                      name="Experienced Caregiver"
                      value="experiencedCaregiver"
                      ><p>Experienced Caregiver</p></b-form-radio
                    >
                  </div>
                </div>
              </div>
            </validation-provider>
            <validation-provider
              :rules="{ required: true }"
              name="care"
              v-slot="{ errors }"
            >
              <div class="mt-12">
                <p class="input-title-black font-semibold">
                  Who do you care for or who did you care for?
                </p>
                <span
                  class="invalid-feedback"
                  style="display: block"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </span>
                <!-- <div class="mt-4 md:flex justify-between flex-wrap">
                <div class="w-1/3 mb-2">
                  <b-form-radio
                    v-model="profileData[0].careFor"
                    name="Spouse/Partner"
                    value="spouse"
                    ><p>Spouse/Partner</p></b-form-radio
                  >
                </div>
                <div class="w-1/3 mb-2">
                  <b-form-radio
                    v-model="profileData[0].careFor"
                    name="Parent"
                    value="parent"
                    ><p>Parent</p></b-form-radio
                  >
                </div>
                <div class="w-1/3 mb-2">
                  <b-form-radio
                    v-model="profileData[0].careFor"
                    name="Special needs Child"
                    value="specialneedsChild"
                    ><p>Special needs Child</p></b-form-radio
                  >
                </div>
                <div class="w-1/3 mb-2">
                  <b-form-radio
                    v-model="profileData[0].careFor"
                    name="Child"
                    value="child"
                    ><p>Child</p></b-form-radio
                  >
                </div>
                <div class="w-1/3 mb-2">
                  <b-form-radio
                    v-model="profileData[0].careFor"
                    name="careFor"
                    value="Parents"
                    ><p>Sibling</p></b-form-radio
                  >
                </div>
                <div class="w-1/3 mb-2">
                  <b-form-radio
                    v-model="profileData[0].careFor"
                    name="Friend"
                    value="friend"
                    ><p>Friend</p></b-form-radio
                  >
                </div>
                <div class="w-1/3 mb-2">
                  <b-form-radio
                    v-model="profileData[0].careFor"
                    name="Grandparent"
                    value="grandparent"
                    ><p>Grandparent</p></b-form-radio
                  >
                </div>
              </div> -->
                <div class="mt-4 grid grid-cols-3 gap-4">
                  <b-form-checkbox-group v-model="profileData[0].care">
                    <b-form-checkbox
                      id="checkbox-1"
                      name="checkbox-1"
                      value="Spouse/Partner"
                    >
                      Spouse/Partner
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-2"
                      name="checkbox-2"
                      value="Parents"
                    >
                      Parents
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-3"
                      name="checkbox-3"
                      value="Special needs Child"
                    >
                      Special needs Child
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-4"
                      name="checkbox-4"
                      value="Child"
                    >
                      Child
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-5"
                      name="checkbox-5"
                      value="Siblings"
                    >
                      Siblings
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-6"
                      name="checkbox-6"
                      value="Friend"
                    >
                      Friend
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-7"
                      name="checkbox-7"
                      value="Grandparent"
                    >
                      Grandparent
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </div>
              </div>
            </validation-provider>
            <validation-provider
              :rules="{ required: true }"
              name="care"
              v-slot="{ errors }"
            >
              <div class="mt-12">
                <p class="input-title-black font-semibold mb-4">
                  Please specify the illness that you are caregiving for?
                </p>
                <base-input
                  v-model="profileData[0].illness"
                  placeholder="Enter your Whatsapp Number"
                  class="cust-form-border"
                  :rules="{
                    required: true,
                  }"
                  name="Mobile Number"
                >
                </base-input>

                <p class="input-title-black font-semibold mt-8">
                  Which of the following areas do you need the most support?
                </p>
                <span
                  class="invalid-feedback"
                  style="display: block"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </span>
                <div class="mt-4 grid grid-cols-3 gap-4">
                  <b-form-checkbox-group v-model="profileData[0].areas">
                    <b-form-checkbox
                      id="checkbox-8"
                      name="checkbox-8"
                      value="Social"
                    >
                      Social
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-9"
                      name="checkbox-9"
                      value="Psychological"
                    >
                      Psychological
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-10"
                      name="checkbox-10"
                      value="Physical"
                    >
                      Physical
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-11"
                      name="checkbox-11"
                      value="Financial/Legal"
                    >
                      Financial/Legal
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-12"
                      name="checkbox-12"
                      value="Spiritual"
                    >
                      Spiritual
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-13"
                      name="checkbox-13"
                      value="Life/Work Purpose"
                    >
                      Life/Work Purpose
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </div>
              </div>
            </validation-provider>
            <validation-provider
              :rules="{ required: true }"
              name="care"
              v-slot="{ errors }"
            >
              <div class="mt-12">
                <p class="input-title-black font-semibold">
                  What do you think is the most valuable service for caregivers?
                </p>
                <span
                  class="invalid-feedback"
                  style="display: block"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </span>
                <div class="mt-4 grid grid-cols-2 gap-4">
                  <b-form-checkbox-group v-model="profileData[0].service">
                    <b-form-checkbox
                      id="checkbox-14"
                      name="checkbox-14"
                      value="Hiring a good caregiver"
                    >
                      Hiring a good caregiver
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-15"
                      name="checkbox-15"
                      value="Emotional Supporter"
                    >
                      Emotional Supporter
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-16"
                      name="checkbox-16"
                      value="Mental Health"
                    >
                      Mental Health
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-17"
                      name="checkbox-17"
                      value="Figuring out finances for medical need"
                    >
                      Figuring out finances for medical need
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-18"
                      name="checkbox-18"
                      value="Understanding insurance"
                      class="fsize1rem"
                    >
                      Understanding insurance
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-19"
                      name="checkbox-19"
                      value="Legal Support"
                      class="fsize1rem"
                    >
                      Legal Support
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </div>
              </div>
            </validation-provider>
            <validation-provider
              :rules="{ required: true }"
              name="care"
              v-slot="{ errors }"
            >
              <div class="mt-12">
                <p class="input-title-black font-semibold">
                  If you are an active caregiver, whould you like share your
                  caregiving journey on Gentle Warriors or share anonymously on
                  Caregiver Diaries Podcast?
                </p>
                <span
                  class="invalid-feedback"
                  style="display: block"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </span>
                <div class="mt-4 md:flex justify-between flex-wrap">
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="profileData[0].shareJourney"
                      name="Yes1"
                      value="yes"
                      ><p>Yes</p></b-form-radio
                    >
                  </div>
                  <div class="w-2/3">
                    <b-form-radio
                      v-model="profileData[0].shareJourney"
                      name="No1"
                      value="no"
                      ><p>No</p></b-form-radio
                    >
                  </div>
                </div>
              </div>
            </validation-provider>
            <validation-provider
              :rules="{ required: true }"
              name="care"
              v-slot="{ errors }"
            >
              <div class="mt-12">
                <p class="input-title-black font-semibold">
                  If you are an experienced caregiver whould you like to share
                  your experience as it will help us design a program for your
                  need ?
                </p>
                <span
                  class="invalid-feedback"
                  style="display: block"
                  v-if="errors[0]"
                >
                  {{ errors[0] }}
                </span>
                <div class="mt-4 md:flex justify-between flex-wrap">
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="profileData[0].shareExp"
                      name="Yes"
                      value="yes"
                      ><p>Yes</p></b-form-radio
                    >
                  </div>
                  <div class="w-2/3">
                    <b-form-radio
                      v-model="profileData[0].shareExp"
                      name="No"
                      value="no"
                      ><p>No</p></b-form-radio
                    >
                  </div>
                </div>
              </div>
            </validation-provider>
          </div>
          <div v-if="profileData[0].roleType == 'Well Wisher of the caregiver'">
            <div>
              <div class="pt-4 w-full">
                <div class="md:flex">
                  <div class="w-full pt-4">
                    <p class="input-title-black">
                      How are you related to the caregiver?
                    </p>
                    <base-input
                      v-model="profileData[0].relationWithCG"
                      placeholder="Please Enter Input"
                      class="cust-form-border"
                      :rules="{ required: true }"
                      name="relation"
                    >
                    </base-input>
                    <!-- , alpha_num: true  -->
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="pt-4 w-full">
                <div class="md:flex">
                  <div class="w-full pt-4">
                    <p class="input-title-black">
                      As a well-wisher of caregiver, would you like to engage
                      with conversation on Gentle warriors / Humanising our
                      healers?
                    </p>
                    <base-input
                      v-model="profileData[0].engage"
                      placeholder="Enter your location"
                      class="cust-form-border"
                      :rules="{ required: true }"
                      name="location"
                    >
                    </base-input>
                    <!-- , alpha_num: true  -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              profileData[0].roleType ==
              'Healthcare Professional/Profession Caregiver/Nurse'
            "
          >
            <div class="pt-4 w-full">
              <div class="md:flex">
                <div class="w-full pt-4">
                  <p class="input-title-black">
                    Would you like be our guest on Humanising our Healers?
                    (Humanising our healers is a platform where we talk about
                    the unseen side of your professional journey)
                  </p>
                  <base-input
                    v-model="profileData[0].guest"
                    placeholder="Please enter input"
                    class="cust-form-border"
                    :rules="{ required: true }"
                    name="guest permission"
                  >
                  </base-input>
                  <!-- , alpha_num: true  -->
                </div>
              </div>
            </div>
          </div>
          <validation-provider
            :rules="{ required: true }"
            name="care"
            v-slot="{ errors }"
          >
            <div class="mt-12">
              <p class="input-title-black font-semibold">
                Would you like to subscribe our newsletter?
              </p>
              <span
                class="invalid-feedback"
                style="display: block"
                v-if="errors[0]"
              >
                {{ errors[0] }}
              </span>
              <div class="mt-4 md:flex justify-between flex-wrap">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].newsletter"
                    name="Yes2"
                    value="yes"
                    ><p>Yes</p></b-form-radio
                  >
                </div>
                <div class="w-2/3">
                  <b-form-radio
                    v-model="profileData[0].newsletter"
                    name="No2"
                    value="no"
                    ><p>No</p></b-form-radio
                  >
                </div>
              </div>
            </div>
          </validation-provider>
          <validation-provider
            :rules="{ required: true }"
            name="care"
            v-slot="{ errors }"
          >
            <div class="mt-12">
              <p class="input-title-black font-semibold">
                We conduct research from time to time, would you agree to take
                part in our surveys?
              </p>
              <span
                class="invalid-feedback"
                style="display: block"
                v-if="errors[0]"
              >
                {{ errors[0] }}
              </span>
              <div class="mt-4 md:flex justify-between flex-wrap">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].surveys"
                    name="Yes3"
                    value="yes"
                    ><p>Yes</p></b-form-radio
                  >
                </div>
                <div class="w-2/3">
                  <b-form-radio
                    v-model="profileData[0].surveys"
                    name="N3o"
                    value="no"
                    ><p>No</p></b-form-radio
                  >
                </div>
              </div>
            </div>
          </validation-provider>
          <validation-provider
            :rules="{ required: true }"
            name="care"
            v-slot="{ errors }"
          >
            <div class="mt-12">
              <p class="input-title-black font-semibold">
                How did you get to know about us?
              </p>
              <span
                class="invalid-feedback"
                style="display: block"
                v-if="errors[0]"
              >
                {{ errors[0] }}
              </span>
              <div class="mt-4 md:flex justify-between flex-wrap">
                <div class="w-2/3 mb-2">
                  <b-form-radio
                    v-model="profileData[0].platforms"
                    name="Family Member"
                    value="familyMember"
                    ><p>From a Friend/ Family Member</p></b-form-radio
                  >
                </div>
                <div class="w-1/3 mb-2">
                  <b-form-radio
                    v-model="profileData[0].platforms"
                    name="Social Media"
                    value="socialMedia"
                    ><p>Social Media</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].platforms"
                    name="Email1"
                    value="email"
                    ><p>Email</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="profileData[0].platforms"
                    name="Other"
                    value="others"
                    ><p>Other</p></b-form-radio
                  >
                </div>
              </div>
            </div>
          </validation-provider>
          <validation-provider
            :rules="{ required: true }"
            name="care"
            v-slot="{ errors }"
          >
            <div class="mt-12">
              <p class="input-title-black font-semibold">
                How would you want to receive information of Caregiver Saathi?
              </p>
              <span
                class="invalid-feedback"
                style="display: block"
                v-if="errors[0]"
              >
                {{ errors[0] }}
              </span>
              <div class="mt-4 md:flex justify-between flex-wrap">
                <div class="w-3/5 mb-2">
                  <b-form-radio
                    v-model="profileData[0].infoThrough"
                    name="One on One"
                    value="oneOnOne"
                    ><p>One on One</p></b-form-radio
                  >
                </div>
                <div class="w-3/5 mb-2">
                  <b-form-radio
                    v-model="profileData[0].infoThrough"
                    name="Email2"
                    value="email"
                    ><p>Email</p></b-form-radio
                  >
                </div>
                <div class="w-3/5">
                  <b-form-radio
                    v-model="profileData[0].infoThrough"
                    name="Whatsapp"
                    value="whatsapp"
                    ><p>Whatsapp</p></b-form-radio
                  >
                </div>
                <div class="w-3/5">
                  <b-form-radio
                    v-model="profileData[0].infoThrough"
                    name="All"
                    value="all"
                    ><p>All</p></b-form-radio
                  >
                </div>
              </div>
            </div>
          </validation-provider>

          <!-- <div class="locationcity">
            <div class="pt-4 w-full">
              <div class="md:flex">
                <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                  <p class="input-title-black">
                    What are the significant illness that you care receiver is
                    suffering from?
                  </p>
                  <base-input
                    v-model="profileData[0].illness"
                    placeholder=""
                    name="illness"
                    class="cust-form-border"
                    :rules="{ required: true, alpha_dash: true }"
                  ></base-input>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <validation-provider
            :rules="{ required: true }"
            name="support"
            v-slot="{ errors }"
          >
            <div class="mt-12">
              <p class="input-title-black font-semibold">
                How would you want to receiver information on caregiver support?
              </p>
              <span
                class="invalid-feedback"
                style="display: block"
                v-if="errors[0]"
              >
                {{ errors[0] }}
              </span>
              <div class="aligncheck">
                <b-form-group>
                  <b-form-checkbox-group
                    id="checkbox-group-1"
                    v-model="profileData[0].supportType"
                    aria-describedby="ariaDescribedby"
                    name="support"
                  >
                    <div class="mt-4 md:flex justify-between items-center">
                      <div class="w-1/3">
                        <b-form-checkbox value="One on One"
                          >One on One</b-form-checkbox
                        >
                      </div>
                      <div class="w-1/3">
                        <b-form-checkbox value="Email">Email</b-form-checkbox>
                      </div>
                      <div class="w-1/3">
                        <b-form-checkbox value="Whatsapp"
                          >Whatsapp</b-form-checkbox
                        >
                      </div>
                    </div>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
              <div class="mt-4 md:flex justify-between">
                  <div class="w-1/3">
                    <b-form-radio
                      v-model="support"
                      name="support"
                      value="Support Group"
                      ><p>Support Group</p></b-form-radio
                    >
                  </div>
                </div>
            </div>
          </validation-provider> -->
          <div>
            <base-button
              type="primary"
              native-type="submit"
              :disabled="isValidForm"
              class="md:px-10 lg:px-10 px-6 md:py-2 lg:py-2 py-1 border-2 text-base font-bold mt-12"
              >Update</base-button
            >
          </div>
          <div>
            <base-button
              type="danger"
              @click="deactivate"
              class="md:px-10 lg:px-10 px-6 md:py-2 lg:py-2 py-1 border-2 text-base font-bold mt-12"
              >Deactivate account</base-button
            >
          </div>
        </b-form>
      </validation-observer>
      <div class="py-8"></div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import VueCountdown from "@chenfengyuan/vue-countdown";
import emailMixin from "@/mixins/email";
import { mapState } from "vuex";

export default {
  mixins: [emailMixin],
  data() {
    return {
      fname: "",
      lname: "",
      email: "",
      mobile: "",
      otp: "",
      verify: false,
      verified: false,
      // time: 30000,

      // password: "",
      age: "",
      occupation: "",
      location: "",
      city: "",
      role: "",
      experience: "",
      careFor: "",
      illness: "",
      area: [],
      support: [],
      value: "",
    };
  },
  components: {
    countdown: VueCountdown,
  },
  methods: {
    async deactivate() {
      try {
        this.$swal
          .fire({
            text: "Are you sure you want to deactivate your account?",
            icon: "info",
            confirmButtonColor: "#830c81",
            showCancelButton: true,
            showCloseButton: true,
          })
          .then(async (result) => {
            console.log(result);
            if (result.value) {
              let data = await this.$store.dispatch("eLearning/userInactive", {
                isActive: false,
                _id: this.userData._id,
              });
              if (data.code == 200) {
                this.$swal.fire({
                  text: "Your profile has been deactivated",
                  icon: "success",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
                await this.$store.dispatch("auth/logout");
                await this.$store.commit("auth/logout");
                this.$router.push({ name: "home" });
              }
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    async register() {
      let payload = {
        _id: this.userData._id,
        firstname: this.userData.firstname,
        lastname: this.userData.lastname,
        mobile: this.userData.mobile,
        email: this.userData.email,
        age: this.profileData[0].age,
        occupation: this.profileData[0].occupation,
        address: this.profileData[0].address,
        city: this.profileData[0].city,
        roleType: this.profileData[0].roleType,
        experience: this.profileData[0].experience,
        careFor: this.profileData[0].careFor,
        illness: this.profileData[0].illness,
        areas: this.profileData[0].areas,
        supportType: this.profileData[0].supportType,
        service: this.profileData[0].service,
        whatsappNo: this.profileData[0].whatsappNo,
        profession: this.profileData[0].profession,
        careForPatient: this.profileData[0].careForPatient,
        category: this.profileData[0].category,
        shareCategory: this.profileData[0].shareCategory,
        shareExp: this.profileData[0].shareExp,
        relationWithCG: this.profileData[0].relationWithCG,
        engage: this.profileData[0].engage,
        newsletter: this.profileData[0].newsletter,
        surveys: this.profileData[0].surveys,
        platforms: this.profileData[0].platforms,
        infoThrough: this.profileData[0].infoThrough,
        care: this.profileData[0].care,
        guest: this.profileData[0].guest,
      };
      // console.log(payload);
      let loader = this.$loading();
      try {
        const data = await this.$store.dispatch("eLearning/editUser", payload);
        if (data.code == 200) {
          loader.close();
          this.$swal.fire({
            text: "Your profile has been updated successfully",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    handlesignin() {
      this.$router.push({ name: "signin" });
    },
  },
  async mounted() {
    // console.log(this.userData);
    // console.log(this.profileData, "abcd");
    await this.$store.dispatch("eLearning/getProfile", {
      userId: this.userData._id,
    });
    // this.$store.dispatch("eLearning/editUser", payload);
  },
  computed: {
    ...mapState("auth", {
      userData: "userData",
    }),
    ...mapState("eLearning", {
      profileData: "profileData",
    }),
    isInvalid() {
      return this.errors.any();
    },
    isValidForm() {
      this.fname != "" &&
        this.lname != "" &&
        this.mobile != "" &&
        this.password != "" &&
        this.email != "" &&
        this.location != "" &&
        this.city != "";
    },
  },
};
</script>
<style lang="scss">
.p-0card > .card-body {
  padding: 0px !important;
}

.root > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.root > div > .nav-tabs .nav-link {
  width: 220px;
  display: flex;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
    height: 60px;
  }
}
.root-il > div > .nav-tabs .nav-link {
  width: 120px;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
  }
}
/* Oveerflow */
.cust-of > div > .nav {
  overflow-x: auto !important;
}
.cust-of > div > .nav::-webkit-scrollbar {
  width: 8px !important;
  height: 12px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-thumb:hover {
  background: #d6d6d6 !important;
}

.cust-of > div > .nav::-webkit-scrollbar-thumb {
  background: #d6d6d6 !important;
  border-radius: 6px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px #80808026 !important;
  border-radius: 6px !important;
}
.scope-padding > .card-body {
  padding-left: 0%;
  padding-right: 0%;
  padding-top: 0%;
  padding-bottom: 0%;
}

.root-il > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root-il > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root-il > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root-il > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root-il > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.aligncheck .custom-control-label {
  padding-top: 4px;
}
.cust-form-border > fieldset > div > div > input {
  border: 2px solid #830c81;
}
.form-group {
  margin-bottom: 0px !important;
}
.mt-9px {
  margin-top: 9px;
}
.fsize1rem .custom-control-label {
  font-size: 1rem;
}
</style>
